<div class="video-modal modal-dialog-scrollable ">
    <div class="modal-header">
        <div class="text-center">Assign Image to Category - {{ categoryName }}</div>

        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-auto">
                <div class="row h-100">
                    <div class="col-12 align-self-end" style="position: relative; left:30px">
                        <label class="text border p-2">
                           DICOM File Name -  <strong> {{ studyFile?.originalFileName.slice(0, -4) }} </strong> 
                        </label><br/>
                        <label class="text"><strong>QUICK FILTERS</strong></label>

                        <div class="modal-footer border-0 justify-content-start">
                            AREA -
                            <button class="btn rounded-3 btn-outline-primary"
                                    [ngClass]="{'btn-primary': selectedGroupNames.includes(mediaGroup.name)}"
                                    *ngFor="let mediaGroup of mediaGroups"
                                    (click)="applyFilter(mediaGroup.name, 'media', $event)">
                                {{mediaGroup.name}}
                            </button>
                        </div>

                        <div class="modal-footer border-0 justify-content-start">
                            F/H - &nbsp;&nbsp;
                            <button class="btn rounded-3 btn-outline-primary"
                                    [ngClass]="{'btn-primary': selectedForeOrHinds.includes('Fore')}"
                                    (click)="applyFilter('Fore', 'foreOrHind', $event)">
                                FORE
                            </button>

                            <button class="btn rounded-3 btn-outline-primary"
                                    [ngClass]="{'btn-primary': selectedForeOrHinds.includes('Hind')}"
                                    (click)="applyFilter('Hind', 'foreOrHind', $event)">
                                HIND
                            </button>

                            &nbsp;&nbsp; Status -
                            <button class="btn rounded-3 btn-outline-primary"
                                    [ngClass]="{'btn-primary': selectedAssignedOrUnAssigned.includes(true)}"
                                    (click)="applyFilter(true, 'assign', $event)">
                                ASSIGNED
                            </button>

                            <button class="btn rounded-3 btn-outline-primary"
                                    [ngClass]="{'btn-primary': selectedAssignedOrUnAssigned.includes(false)}"
                                    (click)="applyFilter(false, 'assign', $event)">
                                UNASSIGNED
                            </button>
                        </div>
                    </div>


                    <div class="col-8 " style="position: relative; left:30px">
                        <!-- Search Input -->
                        <input type="text"
                               class="form-control ps-5 pe-5"
                               placeholder="Search..."
                               [(ngModel)]="searchText"
                               (keyup)="Search($event)" />
                        <!-- Magnifying Glass Icon -->
                        <i class="fa fa-search position-absolute text-muted"
                           style="top: 45%; left: 25px; transform: translateY(-50%); pointer-events: none;">
                        </i>
                        <!-- Clear (Times) Icon -->
                        <i *ngIf="searchText"
                           class="fa fa-times position-absolute text-secondary"
                           style="top: 45%; right: 25px; transform: translateY(-50%); cursor: pointer;"
                           (click)="clearSearch()">
                        </i>
                    </div>
                </div>
            </div>
            <div class="col text text-end me-4">
                <img [src]="studyFile.thumbURL" (click)="viewImage()" class="cursor-pointer" width="150" />
            </div>
        </div>
        <div class="row px-4 py-2">
            <div class="col-6">
                <div class="table-responsive data-grid mt-3 sticky-header-table sticky-header-table-height-xlg">
                  <table mat-table [dataSource]="dataSource" class="table table-hover">
                    <ng-container matColumnDef="name">
                      <th mat-header-cell
                          class="lot-number-heading col-3"
                          *matHeaderCellDef>
                        Repo Category Name
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div class="ps-2">
                          {{ element?.name }} 
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="assignedFileName">
                      <th mat-header-cell class="horse-name-heading col-3" *matHeaderCellDef>
                        Matched File Name
                      </th>
                      <td mat-cell *matCellDef="let element" class="less-height-2-rem">
                        {{ element.assignedFileName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="mediaGroupName">
                      <th mat-header-cell
                          *matHeaderCellDef
                          class="horse-age-category-heading col-auto">
                        AREA
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.mediaGroupName }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="foreOrHind">
                      <th mat-header-cell
                          *matHeaderCellDef
                          class="consignor-heading col-auto">
                        F/H
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.foreOrHind }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="leftOrRight">
                      <th mat-header-cell
                          *matHeaderCellDef
                          class="consignor-heading col-auto">
                        SIDE
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.leftOrRight }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                      <th mat-header-cell
                          *matHeaderCellDef
                          class="action-heading col-auto"></th>
                      <td mat-cell *matCellDef="let element">
                        <div>
                          <button class="btn btn-link text-warning"
                                  *ngIf="element.isShowReplace"
                                  (click)="changeCategory(element.id, true)">
                            REPLACE
                          </button>
                          <button class="btn btn-link text-warning"
                                  *ngIf="element.matched && element.id !== selectedCategoryId"
                                  (click)="changeCategory(element.id, false,true)">
                            <i class="fa fa-plus"></i> Extra
                          </button>
                          <button class="btn btn-link text-info"
                                  *ngIf="element.isShowAssign"
                                  (click)="changeCategory(element.id)">
                            ASSIGN
                          </button>

                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                    <tr id="tr_cat_{{row.id}}"
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                        class="table-row border-start-0 border-end-0 pointer pt-2"
                        [class.active]="row.id === selectedCategoryId"></tr>
                  </table>
                </div>
            </div>
            <div class="col-6">
                <div class="table-responsive data-grid mt-3 sticky-header-table sticky-header-table-height-xlg">
                    <table mat-table [dataSource]="dataSource2" class="table table-hover">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell
                                class="lot-number-heading col-3"
                                *matHeaderCellDef>
                                Repo Category Name
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="ps-2">
                                    {{ element?.name }}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="assignedFileName">
                            <th mat-header-cell class="horse-name-heading col-3" *matHeaderCellDef>
                                Matched File Name
                            </th>
                            <td mat-cell *matCellDef="let element" class="less-height-2-rem">
                                {{ element.assignedFileName }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="mediaGroupName">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="horse-age-category-heading col-auto">
                                AREA
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.mediaGroupName }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="foreOrHind">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="consignor-heading col-auto">
                                F/H
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.foreOrHind }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="leftOrRight">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="consignor-heading col-auto">
                                SIDE
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.leftOrRight }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell
                                *matHeaderCellDef
                                class="action-heading col-auto"></th>
                            <td mat-cell *matCellDef="let element">
                              <div>
                               <button class="btn btn-link text-warning"
                                        *ngIf="element.isShowReplace"
                                        (click)="changeCategory(element.id, true)">
                                  REPLACE
                                </button>
                                <button class="btn btn-link text-warning"
                                        *ngIf="element.matched && element.id !== selectedCategoryId"
                                        (click)="changeCategory(element.id, false,true)">
                                 <i class="fa fa-plus"></i> Extra
                                </button>
             
                                  <button class="btn btn-link text-info"
                                           *ngIf="element.isShowAssign"
                                          (click)="changeCategory(element.id)">
                                    ASSIGN 
                                  </button>
 
                              </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                        <tr id="tr_cat_{{row.id}}"
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                            class="table-row border-start-0 border-end-0 pointer pt-2"
                            [class.active]="row.id === selectedCategoryId"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-end">
        <button class="btn btn-secondary width-btn" (click)="dismiss()">
           Cancel
        </button>
        <button class="btn btn-danger" (click)="discardImage()">
            Discard Image
        </button>
        <!--<button class="btn btn-success flex-grow-1"
                *ngIf="!studyFile.isAdditional && !hideUploadAsAdditional"
                (click)="addToAdditional()">
            Upload to Additional Images
        </button>-->
    </div>
</div>
